export default function Minus() {
  return (
    <div>
      <svg
        width='24'
        height='24'
        viewBox='0 0 63 64'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M8.76074 0.5H61.5586V63.5H8.76074C4.61861 63.5 1.26074 60.1421 1.26074 56V8C1.26074 3.98724 4.41213 0.710536 8.375 0.509766L8.76074 0.5Z'
          fill='#F4F4F4'
        />
        <path
          d='M8.76074 0.5H61.5586V63.5H8.76074C4.61861 63.5 1.26074 60.1421 1.26074 56V8C1.26074 3.98724 4.41213 0.710536 8.375 0.509766L8.76074 0.5Z'
          stroke='#EBEDF3'
        />
        <path
          d='M21.7607 32H42.2607'
          stroke='#222222'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </div>
  );
}
